import type { Invitation, Pass, Site } from '@sine/sine-core-api-types';

import type { RxEventPayloadBase } from '../../../components/events';

export enum RxEvent {
  ACTIVE_PASS_COUNT_UPDATE = 'ACTIVE_PASS_COUNT_UPDATE',
  BILLING_MODE_UPDATED = 'BILLING_MODE_UPDATED',
  CHALLENGE_REQUIRED = 'CHALLENGE_REQUIRED',
  INVITATION_UPDATED = 'INVITATION_UPDATED',
  INVITATIONS_LIST_UPDATED = 'INVITATIONS_LIST_UPDATED',
  LICENCE_UPDATED = 'LICENCE_UPDATED',
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  PASS_ACTIVATED = 'PASS_ACTIVATED',
  PASS_ADMIN_NOTES_UPDATED = 'PASS_ADMIN_NOTES_UPDATED',
  PASS_CREATED = 'PASS_CREATED',
  PASS_EXPIRED = 'PASS_EXPIRED',
  PASS_REJECTED = 'PASS_REJECTED',
  PASS_UPDATED = 'PASS_UPDATED',
  SITE_ADDED = 'SITE_ADDED',
  SITE_DELETED = 'SITE_DELETED',
  SITE_DUPLICATED_MODAL = 'SITE_DUPLICATED_MODAL',
  SITE_UPDATED = 'SITE_UPDATED',
  TEAM_CHANGED = 'TEAM_CHANGED',
  TEAM_CREATED = 'TEAM_CREATED',
  TEAM_FEATURE_CHANGED = 'TEAM_FEATURE_CHANGED',
  TEAM_PERMISSIONS_REFETCHING = 'TEAM_PERMISSIONS_REFETCHING',
  TEAM_PERMISSIONS_REFRESHED = 'TEAM_PERMISSIONS_REFRESHED',
  TRIAL_DATA_LOADING = 'TRIAL_DATA_LOADING',
  TRIMPASS = 'TRIMPASS',
  UPCOMING_INVITATIONS_CHANGED = 'UPCOMING_INVITATIONS_CHANGED',
  USER_DETAILS_UPDATED = 'USER_DETAILS_UPDATED',
  USER_PERMISSIONS_CHANGED = 'USER_PERMISSIONS_CHANGED',
  USER_SOFT_DELETED = 'USER_SOFT_DELETED',
}

export type RxEventPayloadMap = {
  [RxEvent.ACTIVE_PASS_COUNT_UPDATE]: RxEventPayloadBase<RxEvent.ACTIVE_PASS_COUNT_UPDATE, { count: number }>;
  [RxEvent.BILLING_MODE_UPDATED]: RxEventPayloadBase<RxEvent.BILLING_MODE_UPDATED>;
  [RxEvent.CHALLENGE_REQUIRED]: RxEventPayloadBase<RxEvent.CHALLENGE_REQUIRED, { targetUserId?: string }>;
  [RxEvent.INVITATION_UPDATED]: RxEventPayloadBase<RxEvent.INVITATION_UPDATED, { invitation: Invitation }>;
  [RxEvent.INVITATIONS_LIST_UPDATED]: RxEventPayloadBase<RxEvent.INVITATIONS_LIST_UPDATED>;
  [RxEvent.LICENCE_UPDATED]: RxEventPayloadBase<RxEvent.LICENCE_UPDATED>;
  [RxEvent.LOGIN]: RxEventPayloadBase<RxEvent.LOGIN>;
  [RxEvent.LOGOUT]: RxEventPayloadBase<RxEvent.LOGOUT>;
  [RxEvent.PASS_ACTIVATED]: RxEventPayloadBase<RxEvent.PASS_ACTIVATED, { pass: Pass }>;
  [RxEvent.PASS_ADMIN_NOTES_UPDATED]: RxEventPayloadBase<RxEvent.PASS_ADMIN_NOTES_UPDATED, { pass: Pass }>;
  [RxEvent.PASS_CREATED]: RxEventPayloadBase<RxEvent.PASS_CREATED, { pass: Pass }>;
  [RxEvent.PASS_EXPIRED]: RxEventPayloadBase<RxEvent.PASS_EXPIRED, { pass: Pass }>;
  [RxEvent.PASS_REJECTED]: RxEventPayloadBase<
    RxEvent.PASS_REJECTED,
    { expiredPasses: Array<Pass>; rejectedPass: Pass }
  >;
  [RxEvent.PASS_UPDATED]: RxEventPayloadBase<RxEvent.PASS_UPDATED, { pass: Pass }>;
  [RxEvent.SITE_ADDED]: RxEventPayloadBase<RxEvent.SITE_ADDED, { site: Site }>;
  [RxEvent.SITE_DELETED]: RxEventPayloadBase<RxEvent.SITE_DELETED>;
  [RxEvent.SITE_DUPLICATED_MODAL]: RxEventPayloadBase<RxEvent.SITE_DUPLICATED_MODAL>;
  [RxEvent.SITE_UPDATED]: RxEventPayloadBase<RxEvent.SITE_UPDATED, { site: Site }>;
  [RxEvent.TEAM_CHANGED]: RxEventPayloadBase<RxEvent.TEAM_CHANGED>;
  [RxEvent.TEAM_CREATED]: RxEventPayloadBase<RxEvent.TEAM_CREATED>;
  [RxEvent.TEAM_FEATURE_CHANGED]: RxEventPayloadBase<RxEvent.TEAM_FEATURE_CHANGED>;
  [RxEvent.TEAM_PERMISSIONS_REFETCHING]: RxEventPayloadBase<RxEvent.TEAM_PERMISSIONS_REFETCHING>;
  [RxEvent.TEAM_PERMISSIONS_REFRESHED]: RxEventPayloadBase<RxEvent.TEAM_PERMISSIONS_REFRESHED>;
  [RxEvent.TRIAL_DATA_LOADING]: RxEventPayloadBase<RxEvent.TRIAL_DATA_LOADING>;
  [RxEvent.TRIMPASS]: RxEventPayloadBase<RxEvent.TRIMPASS, { pass: Pass }>;
  [RxEvent.UPCOMING_INVITATIONS_CHANGED]: RxEventPayloadBase<
    RxEvent.UPCOMING_INVITATIONS_CHANGED,
    { invitations: Array<Invitation> }
  >;
  [RxEvent.USER_DETAILS_UPDATED]: RxEventPayloadBase<RxEvent.USER_DETAILS_UPDATED>;
  [RxEvent.USER_PERMISSIONS_CHANGED]: RxEventPayloadBase<RxEvent.USER_PERMISSIONS_CHANGED>;
  [RxEvent.USER_SOFT_DELETED]: RxEventPayloadBase<RxEvent.USER_SOFT_DELETED>;
};
